import { render } from "./FirePermit.vue?vue&type=template&id=86f4738c&scoped=true"
import script from "./FirePermit.vue?vue&type=script&lang=js"
export * from "./FirePermit.vue?vue&type=script&lang=js"

import "./FirePermit.vue?vue&type=style&index=0&id=86f4738c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f4738c"]])

export default __exports__